/**
 * Entity adapter declarations for the Account Leadsheet 294 feature.
 *
 * Single source of truth for every `createEntityAdapter()` instance used by the
 * leadsheet slice. The slice owns all adapter mutation calls (`setAll`,
 * `upsertOne`, `upsertMany`, `removeOne`, `updateOne`, `getInitialState`);
 * the normalizer and row generator only read from EntityState. Each adapter
 * backs a sibling EntityState bucket on `state.leadsheet`
 * (`tbData`, `fsData`, `accountSubClassData`, `glAccountData`, `referenceData`,
 * `tickmarkData`), and only one trial balance is held at a time.
 */
import {createEntityAdapter} from '@reduxjs/toolkit';

const selectTrialBalanceId = (tb) => tb?.id;
const selectFinancialStatementId = (fs) => fs?.id;
const selectAccountSubClassId = (sc) => sc?.id;
const selectGlAccountId = (gl) => gl?.id;
const selectReferenceId = (ref) => ref?.docId;
const selectTickmarkId = (tm) => tm?.engTagId;

/** Adapter backing `state.leadsheet.tbData` (single trial balance entity). */
export const leadsheetAdapter = createEntityAdapter({selectId: selectTrialBalanceId});

/** Adapter backing `state.leadsheet.fsData`. */
export const financialStatementAdapter = createEntityAdapter({selectId: selectFinancialStatementId});

/** Adapter backing `state.leadsheet.accountSubClassData`. */
export const accountSubClassAdapter = createEntityAdapter({selectId: selectAccountSubClassId});

/** Adapter backing `state.leadsheet.glAccountData`. */
export const glAccountAdapter = createEntityAdapter({selectId: selectGlAccountId});

/** Adapter backing `state.leadsheet.referenceData`. */
export const referenceAdapter = createEntityAdapter({selectId: selectReferenceId});

/** Adapter backing `state.leadsheet.tickmarkData`. */
export const tickmarkAdapter = createEntityAdapter({selectId: selectTickmarkId});
